import { render, staticRenderFns } from "./TaskTagsList.vue?vue&type=template&id=753a36a4&scoped=true&"
import script from "./TaskTagsList.vue?vue&type=script&lang=js&"
export * from "./TaskTagsList.vue?vue&type=script&lang=js&"
import style0 from "./TaskTagsList.vue?vue&type=style&index=0&id=753a36a4&lang=scss&scoped=true&"
import style1 from "./TaskTagsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "753a36a4",
  null
  
)

export default component.exports